import React from "react";
import PropTypes from 'prop-types';
import { Box, Stack, Typography, Paper, IconButton } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import CloseIcon from '@mui/icons-material/Close';

DropzoneImage.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func,
  label: PropTypes.string
};

export default function DropzoneImage({ value, setValue, label = "Upload Image" }) {
  const onDrop = (acceptedFiles) => {
    if (!acceptedFiles?.length) return;

    const file = acceptedFiles[0];

    const reader = new FileReader();
    reader.onload = (e) => {
      setValue(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    noClick: true,
    noKeyboard: true,
  });

  const removeImage = () => setValue('');

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1" sx={{ mt: 1 }}>
        {label}
      </Typography>

      <Box display="flex" gap={2} alignItems="flex-start">
        <Box {...getRootProps()} sx={{ cursor: 'pointer', flex: 1 }} onClick={open}>
          <input {...getInputProps()} />
          <Paper
            elevation={isDragActive ? 6 : 1}
            sx={{
              p: 1,
              border: 1,
              borderColor: 'info.main',
              color: 'info.main',
              bgcolor: 'background.paper',
              transition: '0.2s',
              '&:hover': { boxShadow: 3, bgcolor: 'background.default' },
            }}
          >
            <Typography variant="body2" textAlign="center">
              {isDragActive ? "Drop the image" : "Click to Upload or Drag and Drop"}
            </Typography>
          </Paper>
        </Box>

        {value && (
          <Box
            position="relative"
            width={128}
            height={128}
            borderRadius={2}
            overflow="hidden"
            sx={{
              border: "2px solid #ddd",
              bgcolor: "white",
            }}
          >
            <IconButton
              size="small"
              onClick={removeImage}
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                bgcolor: "rgba(255,255,255,0.85)",
                "&:hover": { bgcolor: "white" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            <img
              src={value}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                padding: "6px",
                background: "#fafafa",
              }}
            />
          </Box>
        )}
      </Box>
    </Stack>
  );
}
